"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AppContext = exports.AppContext = /*#__PURE__*/_react["default"].createContext({
  session: undefined,
  access: undefined,
  appId: undefined,
  setSession: function setSession(session, tenantId) {},
  removeSession: function removeSession() {},
  onSignedIn: function onSignedIn() {},
  onChangedAccess: function onChangedAccess(tenantId) {},
  isGranted: function isGranted(action) {
    return false;
  },
  isGrantedAny: function isGrantedAny(actions) {
    return false;
  },
  fixPath: function fixPath(path, tenantId) {
    return path;
  }
});